<template>
  <v-btn :disabled="isDisable" @click="$emit('click')" class="btn" :class="{'active': isActive} ">
    <p class="text-caption">
      {{ title }}
    </p>

       <slot></slot>

  </v-btn>
</template>

<script>
export default
{
    props:{
      title: {type: String, required: false},
      isActive:{type:Boolean, required:false},
      isDisable:{type:Boolean, required:false}
    }
}
</script>

<style>

.btn{
    justify-content: center;
    background: rgba(0, 0, 0, .8);
    align-items: center;
    border-radius: 4px;
    padding:0rem 1rem;
    height:35px;
}

.btn p {
    font-weight: 100;
    margin: 0 !important;
    padding:0 !important;

}
.active
{
  background:#ffbf00 !important;
  color:black !important;
}
</style>